import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

export class CreateTicketGiftCardSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = 'a250781dbd5e48139ef618b36e5880e8';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateTicketGiftCard;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return CreateTicketGiftCardSideEffect.TYPE_ID;
  }

  static create(): CreateTicketGiftCardSideEffect {
    return new CreateTicketGiftCardSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): CreateTicketGiftCardSideEffect {
    return new CreateTicketGiftCardSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new CreateTicketGiftCardSideEffect() as this;
  }

  isSame(other: CreateTicketGiftCardSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.CreateGiftCard);
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateTicketGiftCardSideEffect;
  }

  static assertType(order: DataModel): order is CreateTicketGiftCardSideEffect {
    return order instanceof CreateTicketGiftCardSideEffect;
  }
}

export class CreateTicketGiftCardSideEffectBuilder extends DataModelBuilder<CreateTicketGiftCardSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateTicketGiftCardSideEffect {
    return CreateTicketGiftCardSideEffect.fromMap(context, map);
  }
}
